import styled from 'styled-components';

export const ContainerTitle = {
  display: 'flex',
  flexDirection: 'row',
  width: '50%'
};

{
  /* estilização do gráfico de pizza CallCenter Dashboard*/
}

export const legendContainer = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  justifyContent: 'center',
  marginTop: '20px'
};

export const legendItem = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

export const legendColor = {
  width: '14px',
  height: '14px',
  borderRadius: '50%'
};

export const legendLabel = {
  fontSize: '14px',
  color: '#333'
};

{
  /* estilização dos Cards CallCenter Dashboard*/
}
export const TopCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr 1fr;
  gap: 1em;
  padding: 1rem;

  #big-card {
    grid-row: span 2;
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;

    > div {
      min-height: revert !important;
      height: revert !important;
      margin-bottom: revert !important;
      inset: 0;
      position: absolute;
      display: grid;
      place-items: center;
    }
  }
`;
